import { assetsPath } from "../../utils";

const maps = `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/master-plan/image.jpg`;

export default {
  maps
};



// WEBPACK FOOTER //
// ./src/data/PhuketDusitDeluxePoolVilla/masterplan.js